<template>
	<div class="container">
		<div v-if="nowData" class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="msg_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="img" src="../../assets/SSB/logo.webp" />
					<div class="tit">Scientific Strategy Board</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div v-if="nowData" class="block_2_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="500"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">
						<van-image width="350" height="350" :src="nowData.image" />
					</div>
					<div class="right">
						<div class="tit">{{ nowData.title }}</div>
						<div class="txt" v-html="nowData.text1"></div>
						<div class="txt" v-html="nowData.text2"></div>
						<div class="txt" v-html="nowData.text3"></div>
						<div class="content" v-html="nowData.desc"></div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div v-if="nowData.publicationsList.length > 0" class="block_3">
				<div class="block_3_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="500"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Publications</div>
					<div class="list_box">
						<div v-for="(value, index) in nowData.publicationsList" :key="index" :style="{ 'backgroundColor': value.bgcolor }" class="list_el">
							<div class="text">{{ value.text }}</div>
							<div class="btn_box_more btn_box" @click="goUrl(value)">
								Learn More<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="bg"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="500"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../assets/SSB/bot_bg.webp" />
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			listData: [
				{
					name: 'AlbertP.Pisano',
					title: 'Albert P. Pisano',
					text1: '<span>·&ensp;</span><span>Dean, Jacobs School of Engineering UCSD</span>',
					text2: '<span>·&ensp;</span><span>American Society of Mechanical Engineers</span>',
					text3: '<span>·&ensp;</span><span>Chair, Scientific Strategy Board, CorDx Healthcare</span>',
					image: require('@/assets/SSB/ren_1.webp'),
					desc: "<p>Albert P. Pisano, a self-described technology polymath, is renowned for his groundbreaking work in micro-electro-mechanical systems (MEMS) and his passion for leveraging technology to address complex challenges. His research spans a wide range of applications, from the development of MEMS wireless sensors for harsh environments, such as gas turbines and geothermal wells, to pioneering additive MEMS manufacturing techniques, including low-temperature nano-printing of nanoparticle inks and polymer solutions. Pisano’s innovative work also extends to RF components, power generation, drug delivery, biosensors, and nanowire sensors, positioning him as a leader in the MEMS field. He holds over 36 patents in MEMS technology and has authored more than 400 academic publications.</p><p>Beyond MEMS, Pisano is dedicated to developing cost-effective, large-scale sensors made from sustainably sourced polymers for applications in healthcare, environmental monitoring, and food safety. His entrepreneurial spirit is reflected in his co-founding of ten start-up companies, focusing on areas such as transdermal and transvascular drug delivery, sensorized catheters, and MEMS manufacturing equipment. His impact on the medical technology industry earned him a place on Medical Devices and Diagnostic Industry (MD&DI) Magazine's list of 100 Notable People in 2008.</p><p>As the Chair of CorDx Healthcare’s Scientific Strategy Board, Pisano brings decades of expertise in MEMS technology and sensor development. His forward-thinking approach to healthcare innovation and sustainability will provide invaluable insights as CorDx continues to push the boundaries of diagnostics and therapeutic technologies.</p>",
					publicationsList: [
						{
							bgcolor: '#FEFBF3',
							text: 'Broadman, H. G., Guile, B. R., Delpy, D. T., & Pisano, A. P. (2021). Capitalizing on the G7 Research Compact. Science, 374(6571), 1056–1058.',
							linkurl: 'https://www.science.org/doi/10.1126/science.abm4781'
						},{
							bgcolor: '#F1FBF4',
							text: 'Zou, J., Gao, A., & Pisano, A. P. (2020). Ultralow acoustic loss micromachined butterfly Lamb wave resonators on AlN plates. IEEE Transactions on Ultrasonics, Ferroelectrics, and Frequency Control, 67(3), 671–674.',
							linkurl: 'https://ieeexplore.ieee.org/document/8886485'
						}
					]
				},{ 
					name: 'MichaelMina',
					title: 'Michael Mina',
					text1: '<span>·&ensp;</span><span>American epidemiologist, immunologist and physician</span>',
					text2: '<span>·&ensp;</span><span>Previously professor of Harvard T.H. Chan School of Public Health.</span>',
					text3: '<span>·&ensp;</span><span>Co-Chair, Scientific Strategy Board, CorDx Healthcare</span>',
					image: require('@/assets/SSB/ren_2.webp'),
					desc: '<p>Dr. Michael Mina is a distinguished expert in epidemiology and immunology, with a career-long commitment to advancing our understanding of infectious diseases and immune system dynamics. He previously served as an Assistant Professor of Epidemiology at the Harvard T. H. Chan School of Public Health and as a core member of the Center for Communicable Disease Dynamics, as well as Assistant Professor of Immunology and Infectious Diseases at Harvard and Associate Medical Director of Clinical Microbiology at Brigham and Women’s Hospital.</p><p>Dr. Mina’s academic journey uniquely integrates clinical training with pioneering research. He earned his MD and PhD from Emory University, conducting doctoral research at institutions such as the CDC, St. Jude Children’s Research Hospital, and the Emory Vaccine Center. He completed postdoctoral research in infectious disease dynamics at Princeton University and in genetics at Harvard Medical School.</p><p>He has been a leading voice in shaping the United States’ COVID-19 response, particularly through his promotion of widespread, rapid antigen testing as a key tool to curb the pandemic . Dr. Mina helped develop guidelines for PCR and rapid testing strategies, supported the establishment of nation’s largest PCR testing laboratories (e.g., at the Broad Institute of MIT and Harvard), and served as an advisor to the White House, U.S. Congress and Senate, multiple states, and international governments on testing and vaccination programs. Additionally, he proposed the visionary concept of a Global Immunological Observatory—a "viral weather system"—to enhance real-time pandemic surveillance and preparedness.</p><p>As Co‑Chair of CorDx Healthcare’s Scientific Strategy Board, Dr. Mina’s profound insights into epidemiology, immunological surveillance, and pandemic response will be instrumental in guiding the company’s development of next-generation diagnostic and therapeutic solutions.</p>',
					publicationsList: [
						{
							bgcolor: '#FEFBF3',
							text: 'Hay, J. A., Kennedy-Shaffer, L., Kanjilal, S., Lennon, N. J., Gabriel, S. B., Lipsitch, M., & Mina, M. J. (2021). Estimating epidemiologic dynamics from cross-sectional viral load distributions. Science, 373(6552), eabh0635.',
							linkurl: 'https://www.science.org/doi/10.1126/science.abh0635'
						},{
							bgcolor: '#F1FBF4',
							text: 'Lennon, N. J., Bhattacharyya, R. P., Mina, M. J., Rehm, H. L., Hung, D. T., Smole, S., Woolley, A., Lander, E. S., & Gabriel, S. B. (2021). Cross-sectional assessment of SARS-CoV-2 viral load by symptom status in Massachusetts congregate living facilities. Journal of Infectious Diseases, 224(10), 1658–1663.',
							linkurl: 'https://academic.oup.com/jid/article/224/10/1658/6313996'
						}
					]
				},{ 
					name: 'PingLiu',
					title: 'Ping Liu',
					text1: '<span>·&ensp;</span><span>Professor, Aiiso Yufeng Li Family Department of Chemical and Nano Engineering, UCSD</span>',
					text2: '<span>·&ensp;</span><span>Co-founder and CSO, TyFast</span>',
					text3: '<span>·&ensp;</span><span>Director, Scientific Strategy Board, CorDx Healthcare</span>',
					image: require('@/assets/SSB/ren_3.webp'),
					desc: "<p>Professor Ping Liu, a distinguished member of the Aiiso Yufeng Li Family Department of Chemical and Nano Engineering, is renowned for his cutting-edge research in electrochemical energy conversion and storage. His work is dedicated to the design of innovative materials and advanced architectures for rechargeable batteries, with a focus on enhancing their performance and longevity. One of his major areas of research involves studying the mechanical behavior of batteries to optimize them as solid-state actuators and ensure their effectiveness as long-lasting energy storage solutions.</p><p>Professor Liu’s expertise extends to the synthesis of nanostructured materials, where he explores the impact of composition and size on the thermodynamics and kinetics when applied to battery technologies. His pioneering work in this area has significantly advanced the development of high-performance battery materials. In addition, he has made critical contributions to the design of new energy storage architectures, utilizing novel electrolytes, interfacial structure engineering, and innovative battery cell configurations to improve energy density and maintain long service life.</p><p>As a Director of CorDx Healthcare's Scientific Strategy Board, Professor Liu brings a wealth of knowledge in energy storage technologies and material science. His leadership and vision will help steer the company toward the development of sustainable, next-generation healthcare solutions powered by advanced energy technologies.</p>",
					publicationsList: [
						{
							bgcolor: '#FEFBF3',
							text: 'Wu, Z., Wang, C., Hui, Z., Liu, H., Wang, S., Yu, S., Xing, X., Holoubek, J., Miao, Q., Xin, H. L., & Liu, P. (2023). Growing single-crystalline seeds on lithiophobic substrates to enable fast-charging lithium-metal batteries. Nature Energy, 8(4), 340–350.',
							linkurl: 'https://www.nature.com/articles/s41560-023-01202-1'
						},{
							bgcolor: '#F1FBF4',
							text: 'Kuai, D., Wang, S., Perez-Beltran, S., Yu, S., Real, G. A., Liu, P., & Balbuena, P. B. (2024). Interfacial electrochemical lithiation and dissolution mechanisms at a sulfurized polyacrylonitrile cathode surface. ACS Energy Letters, 9(3), 810–818.',
							linkurl: 'https://pubs.acs.org/doi/10.1021/acsenergylett.3c02757'
						}
					]
				},{ 
					name: 'LiangfangZhang',
					title: 'Liangfang Zhang',
					text1: '<span>·&ensp;</span><span>Joan and lrwin Jacobs Chancellor Professor & Chair</span>',
					text2: '<span>·&ensp;</span><span>Professor, Aiiso Yufeng Li Family Department of Chemical and Nano Engineering, UCSD</span>',
					text3: '<span>·&ensp;</span><span>Special Advisor, Scientific Strategy Board, CorDx Healthcare</span>',
					image: require('@/assets/SSB/ren_4.webp'),
					desc: "<p>Professor Liangfang Zhang<br />Joan and Irwin Jacobs Chancellor Professor & Chair<br />Aiiso Yufeng Li Family Department of Chemical and Nano Engineering, UC San Diego<br />Special Advisor, Scientific Strategy Board, CorDx Healthcare</p><p>Dr. Liangfang Zhang is the Joan and Irwin Jacobs Chancellor Professor and Chair of the Aiiso Yufeng Li Family Department of Chemical and Nano Engineering at UC San Diego. He earned his B.E. and M.S. degrees in Chemical Engineering from Tsinghua University, received his Ph.D. in Chemical & Biomolecular Engineering at the University of Illinois at Urbana-Champaign, and completed postdoctoral training in Prof. Robert Langer’s laboratory at MIT. Dr. Zhang joined UC San Diego as an Assistant Professor in 2008, was promoted to Full Professor in 2014, and became the inaugural Joan and Irwin Jacobs Chancellor’s Endowed Chair Professor in Innovations for Engineering in Medicine in 2021. His research focuses on creating innovative biomimetic nanotechnologies for biomedical applications such as countermeasures, drug delivery, vaccines, and diagnostics. He has authored 310 peer-reviewed publications and holds 130 patents and patent applications worldwide. Dr. Zhang is a Fellow of the American Institute for Medical and Biological Engineering (AIMBE, elected 2015), the American Association for the Advancement of Science (AAAS, elected 2018), and the National Academy of Inventors (NAI, elected 2020).</p><p>As Special Advisor to CorDx Healthcare’s Scientific Strategy Board, Professor Zhang contributes leading expertise in nanotechnology and nanomedicine. His strategic guidance is instrumental in advancing CorDx’s mission to develop next-generation diagnostic and therapeutic solutions.</p>",
					publicationsList: [
						{
							bgcolor: '#FEFBF3',
							text: 'Zhou, Z., Mukundan, N., Zhang, J. A., Wu, Y.-T., Zhang, Q., Wang, D., Fang, R. H., Gao, W., & Zhang, L. (2024). Macrophage-mimicking cellular nanoparticles scavenge proinflammatory cytokines in specimens of patients with inflammatory disorders. Advanced Science, 11(31), e2401423.',
							linkurl: 'https://onlinelibrary.wiley.com/doi/10.1002/advs.202401423'
						},{
							bgcolor: '#F1FBF4',
							text: 'Duan, Y., Zhang, E., Fang, R. H., Gao, W., & Zhang, L. (2023). Capsulated cellular nanosponges for the treatment of experimental inflammatory bowel disease. ACS Nano, 17(16), 15893–15904.',
							linkurl: 'https://pubs.acs.org/doi/10.1021/acsnano.3c03959'
						}
					]
				},{ 
					name: 'KevinBan',
					title: 'Kevin Ban',
					text1: '<span>·&ensp;</span><span>U.S. physician leader</span>',
					text2: '<span>·&ensp;</span><span>Former Chief Medical Officer at Walgreens Boots Alliance</span>',
					text3: '<span>·&ensp;</span><span>Medical Advisor, Scientific Strategy Board, CorDx Healthcare</span>',
					image: require('@/assets/SSB/ren_5.webp'),
					desc: "<p>Dr. Kevin Ban is a prominent U.S. physician leader with over 25 years of experience in emergency medicine, healthcare strategy, and public health innovation. He earned his M.D. from Georgetown University and completed residency training at Harvard-affiliated Beth Israel Deaconess Medical Center, later joining the Harvard Medical School faculty.</p><p>In 2020, he was appointed Chief Medical Officer at Walgreens Boots Alliance, where he led the company’s COVID-19 national response, including the expansion of testing and vaccination services across thousands of retail locations. He also developed the Walgreens COVID-19 Index to track viral variants in near real-time.</p><p>As Medical Advisor to CorDx Healthcare’s Scientific Strategy Board, Dr. Ban provides strategic insight in clinical operations, public health alignment, and innovative diagnostic solutions. His leadership helps accelerate CorDx’s global mission to advance next-generation testing and healthcare delivery systems.</p>",
					publicationsList: []
				}
			],
			nowData: null
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		if(that.$route.query.name) {
			that.listData.forEach((value, index) => {
				if(value.name == that.$route.query.name) {
					that.nowData = value;
					that.isLoading = false;
				}
			});
			if(!that.nowData) {
				that.$toast('Error');
			}
		}else {
			that.$toast('Error');
		}
	},
	watch: {
		//
	},
	methods: {
		goUrl(value) {
			if(value.linkurl) {
				window.open(value.linkurl);
			}
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	//块3
	.block_3{
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			padding: 80px 0 20px 0;
			.list_box{
				display: flex;
				padding-top: 20px;
				.list_el{
					flex: 1;
					position: relative;
					margin: 0 20px;
					padding: 30px 30px 120px 30px;
					.btn_box{
						position: absolute;
						bottom: 30px;
					}
					.text{
						font-size: 20px;
						line-height: 1.6;
					}
				}
			}
			.title{
				font-size: 45px;
			}
		}
		.bg{
			img{
				width: 100%;
			}
		}
	}
	//块2
	.block_2{
		width: 100%;
		background: linear-gradient( 180deg, #FFFFFF 0%, #F6FCFF 100%);
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
			padding: 100px 0 80px 0;
			display: flex;
			.left{
				width: 350px;
			}
			.right{
				flex: 1;
				padding-left: 90px;
				.txt{
					padding: 2px 0px;
					font-size: 24px;
				}
				.tit{
					padding: 0px 0 10px 0;
					font-size: 45px;
				}
				.content{
					padding-top: 25px;
				}
			}
		}
	}
	//块1
	.block_1{
		width: 100%;
		padding: 60px 0 45px 0;
		background: linear-gradient( 90deg, #0062B0 0%, #0B318F 100%);
		.msg_box{
			text-align: center;
			.tit{
				padding-top: 15px;
				font-size: 48px;
				color: #ffffff;
			}
			.img{
				width: 190px;
			}
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 44px;
		font-size: 20px;
		color: #0B318F;
		background: transparent;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		// background-color: #f5f8fa;
	}
}
</style>
<style scoped>
>>> .block_2 .right .txt{
	display: flex;
}
>>> .block_2 .right .txt span{
	font-size: 24px;
}
>>> .block_2 .right .content p{
	font-size: 20px;
}
</style>
